var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4971 47.3609V48.7798C20.4971 49.2981 20.9173 49.7183 21.4356 49.7183H32.5722C33.0905 49.7183 33.5107 49.2981 33.5107 48.7798V47.3609C33.5107 46.8426 33.0905 46.4224 32.5722 46.4224H21.4356C20.9173 46.4224 20.4971 46.8426 20.4971 47.3609Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.173 31.1179C17.887 31.1179 21.7084 27.2966 21.7084 22.5826C21.7084 17.8687 17.887 14.0473 13.173 14.0473C8.4591 14.0473 4.6377 17.8687 4.6377 22.5826C4.6377 27.2966 8.4591 31.1179 13.173 31.1179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8185 31.1179C45.5325 31.1179 49.3539 27.2966 49.3539 22.5826C49.3539 17.8687 45.5325 14.0473 40.8185 14.0473C36.1046 14.0473 32.2832 17.8687 32.2832 22.5826C32.2832 27.2966 36.1046 31.1179 40.8185 31.1179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 30.1794C32.8484 30.1794 37.5896 25.4382 37.5896 19.5897C37.5896 13.7412 32.8484 9 26.9999 9C21.1513 9 16.4102 13.7412 16.4102 19.5897C16.4102 25.4382 21.1513 30.1794 26.9999 30.1794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 23.0704C52 36.8821 46.3911 48.063 27.0074 48.063C7.62371 48.063 2 36.8747 2 23.0704H52Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5191 44.671C20.3861 44.671 20.2531 44.6488 20.12 44.6045C14.1121 42.7718 9.16081 38.1827 6.87734 32.3299C6.58174 31.5835 6.95125 30.7411 7.69763 30.4529C8.44401 30.1646 9.28646 30.5267 9.57467 31.2731C11.5404 36.3056 15.8043 40.2518 20.9625 41.8259C21.731 42.0624 22.1597 42.8679 21.9306 43.6364C21.7384 44.2719 21.1472 44.6784 20.5191 44.6636V44.671Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8079",
    x: 0,
    y: 7,
    width: 54,
    height: 44.7183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8079",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryFood);
export default __webpack_public_path__ + "static/media/category_food.aaf0c8c7f5651ee12dbab850ce373f43.svg";
export { ForwardRef as ReactComponent };